import { nonEmptyStringValidator } from '@vista/omnichannel-components-domain';
import { Validator } from '@vista-digital/validator';
/**
 * Default assets for the Event Hero Banner component.
 */
export const defaultEventHeroBannerAssets = {
    scheduleIconName: undefined
};
/**
 * Asset validator for the Event Hero Banner component.
 */
export const eventHeroBannerAssetsValidator = Validator.object({
    scheduleIconName: Validator.optional(nonEmptyStringValidator)
});
